import { Typography } from "@suraasa/placebo-ui"
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogTitle,
  Tag,
} from "@suraasa/placebo-ui-legacy"
import { pluralize } from "utils/helpers"
import { trackingService } from "utils/tracking"
import { TrackingEvents } from "utils/tracking/events"

type Props = {
  open: boolean
  handleClose: () => void
  parentSelector?: () => void
  onSubmit: () => void
  unattemptedQuestionsCount: number
  unreadQuestionsCount: number
  markedForReviewQuestionCount: number
}

const SubmitConfirmationDialog = ({
  open,
  parentSelector,
  unattemptedQuestionsCount,
  unreadQuestionsCount,
  markedForReviewQuestionCount,
  onSubmit,
  handleClose,
}: Props) => {
  const totalQuestionsUnanswered =
    unattemptedQuestionsCount + unreadQuestionsCount

  const handleSubmit = () => {
    trackingService.trackEvent(
      TrackingEvents.cpatConfirmSubmitAssessment,
      {
        unattempted_questions: unattemptedQuestionsCount,
        unread_questions: unreadQuestionsCount,
        marked_for_review: markedForReviewQuestionCount,
        total_unanswered: totalQuestionsUnanswered,
      },
      { services: ["PostHog"] }
    )
    onSubmit()
  }

  return (
    <Dialog
      open={open}
      parentSelector={parentSelector}
      onRequestClose={handleClose}
    >
      <DialogTitle>
        <Typography variant="title3">Submit Assessment?</Typography>
      </DialogTitle>
      <DialogContent>
        <Typography className="mb-1.25">
          Are you sure you want to submit the assessment? This action cannot be
          reversed.
          {(unattemptedQuestionsCount > 0 ||
            unreadQuestionsCount > 0 ||
            markedForReviewQuestionCount > 0) &&
            "\n\nYou still have:"}
        </Typography>
        <div className="mb-1.25 flex flex-wrap gap-1">
          {markedForReviewQuestionCount > 0 && (
            <Tag
              color="warning"
              label={`${pluralize(
                "Question",
                markedForReviewQuestionCount
              )} Marked for Review`}
              size="md"
            />
          )}
          {totalQuestionsUnanswered > 0 && (
            <Tag
              color="critical"
              label={`${pluralize(
                "Question",
                totalQuestionsUnanswered
              )} Unanswered`}
              size="md"
            />
          )}
        </div>
      </DialogContent>
      <DialogFooter
        actions={{
          primary: {
            color: "black",
            label: "Submit",
            onClick: handleSubmit,
          },
        }}
      />
    </Dialog>
  )
}

export default SubmitConfirmationDialog
